import {
  LOAD_KYC_CONTACT_LIST,
  SET_KYC_CONTACT_LIST_LOADING,
  SET_KYC_CONTACT_LIST_DATA,
  LOAD_KYC_CONTACT_DETAIL,
  SET_KYC_CONTACT_DETAIL_LOADING,
  SET_KYC_CONTACT_DETAIL_DATA,
  CLEAR_KYC_CONTACT_DETAIL,
  LOAD_KYC_CONTACT_FILE_URL,
  SET_KYC_CONTACT_FILE_URL,
} from 'state/actionTypes';

export const loadKycContactList = (page, size, filters) => ({
  type: LOAD_KYC_CONTACT_LIST,
  payload: { page, size, filters },
});

export const setKycContactListLoading = isLoading => ({
  type: SET_KYC_CONTACT_LIST_LOADING,
  payload: { isLoading },
});

export const setKycContactListData = (data, paging) => ({
  type: SET_KYC_CONTACT_LIST_DATA,
  payload: { data, paging },
});

export const loadKycContactDetail = id => ({
  type: LOAD_KYC_CONTACT_DETAIL,
  payload: { id },
});

export const setKycContactDetailLoading = isLoading => ({
  type: SET_KYC_CONTACT_DETAIL_LOADING,
  payload: { isLoading },
});

export const setKycContactDetailData = data => ({
  type: SET_KYC_CONTACT_DETAIL_DATA,
  payload: { data },
});

export const clearKycContactDetail = () => ({
  type: CLEAR_KYC_CONTACT_DETAIL,
});

export const loadKycContactFileUrl = (contactId, fileId) => ({
  type: LOAD_KYC_CONTACT_FILE_URL,
  payload: { contactId, fileId },
});

export const setKycContactFileUrl = (fileId, url) => ({
  type: SET_KYC_CONTACT_FILE_URL,
  payload: { fileId, url },
});
